import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {Sorting} from "../../../../../../core/shared/misc/sorting";

//  GROUPBY_WIDGET_ERROR
@Component({
    selector: 'mvs-example',
    templateUrl: 'te-statistics.component.html',
    standalone: false
})
export class TeStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {

    pending: number = 0;
    processed: number = 0;
    inProcess: number = 0;
    unfinished: number = 0;


    templateHistoryWidget: WidgetData;
    templateByContentTypeWidget: WidgetData;
    artefactByContentTypeWidget: WidgetData;
    recentlyAddedTemplateWidget: WidgetData;

    items: MenuItem[] | undefined;

    home: MenuItem | undefined;

    overviewDto: OverviewDto[];

    constructor(
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService) {
        super(route, coreService)
    }

    ngOnInit(): void {


        this.items = [
            {label: 'End User Module'},
        ];

        this.overviewDto = [
            {label: ' Pending', value: 0 },
            {label: ' Processed', value: 0 },
            {label: 'In-Process', value: 0 },
            {label: 'Unfinished', value: 0 }
        ];

        this.home = {icon: 'pi pi-home', routerLink: '/'};
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.refreshTemplateHistoryWidget();
        this.refreshTemplateByContentTypeWidget();
        this.refreshArtefactByContentTypeWidget();
        this.refreshAddedTemplate();
        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/te/config']);
    }



    refreshTemplateHistoryWidget() {
        this.templateHistoryWidget = WidgetFactory.createWidget(
            'te.template.overview.history.widget',
            'Template History',
            'history.chart',
            'list',
            'entity.groupBy',
            'te.TeTemplate',
            WidgetDataParam.create("fieldCategory", "templateGroup"),
            WidgetDataParam.create("fieldCategoryCount", "templateGroup_count"),
            WidgetDataParam.create("historyPeriodMode", "month"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.templateHistoryWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["templateGroup", "createdDate"],
            [new ObjectRequestListAttribute("templateGroup", "Type", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshTemplateByContentTypeWidget() {
        this.templateByContentTypeWidget = WidgetFactory.createWidgetGroupBy(
            'te.overview.template.content.type.widget',
            'Template By Content Type',
            'category',
            'entity.groupBy',
            'te.TeTemplate',
            'contentTypeEnum',
            'contentTypeEnum_count',
            this.filterCriteria,
            'contentTypeEnum',
            'Anzahl');
    }

    refreshArtefactByContentTypeWidget() {
        this.artefactByContentTypeWidget = WidgetFactory.createWidgetGroupBy(
            'te.overview.artefact.content.type.widget',
            'Artefact By Content Type',
            'category',
            'entity.groupBy',
            'te.TeArtefact',
            'contentTypeEnum',
            'contentTypeEnum_count',
            this.filterCriteria,
            'contentTypeEnum',
            'Anzahl');
    }

    refreshAddedTemplate() {
        this.recentlyAddedTemplateWidget = WidgetFactory.createWidgetTableEntityQl('te.overview.recently.added.template', 'Recent Templates', 'te.TeTemplate', 'No Fields', this.filterCriteriaForQuery, [
            new Sorting("e.createdDate", false)
        ]);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
